interface TripDisplayProps {
  origin: string
  destination: string
  customer: string
  number: string
}

export default function TripDisplay({ origin, destination, customer, number }: TripDisplayProps) {
  const loadNumber = number.includes("-") ? number.split("-")[0] : number
  const tripURL = `https://app.alvys.com/#/loads/${loadNumber}/${number}`
  return (
    <div className="flex flex-col items-end">
      <div>
        <a
          href={tripURL}
          target="_blank"
          className="cursor-pointer text-xs text-metric-accent font-semibold"
        >
          {number}
        </a>
      </div>
      <div className="text-[9pt]">{origin} →</div>
      <div className="text-[9pt]">{destination}</div>
      <div className="text-muted-foreground text-xs text-right">{customer}</div>
    </div>
  )
}
